/*
  Produits complémentaires : suit le coloris sélectionné.

  Le bloc est rendu côté serveur pour la variante initiale. Au changement de
  coloris, on redemande le fragment à Shopify via la Section Rendering API
  plutôt que de reconstruire les cartes en JS : prix, promos et disponibilité
  restent ceux du thème, y compris pendant les soldes. Même approche que
  « Vus récemment ».

  Le conteneur est remplacé, jamais démonté : l'écouteur vit sur le document.
*/
(function () {
  var SECTION = 'pairs-with';
  var host = null;
  var pending = null;
  var cache = {};

  function mount() {
    return document.querySelector('[data-pairs-with]');
  }

  function render(variantId) {
    host = mount();
    if (!host || !variantId) return;

    var url = host.getAttribute('data-product-url');
    if (!url) return;

    if (cache[variantId] !== undefined) {
      swap(cache[variantId]);
      return;
    }

    // Une seule requête en vol : un client qui parcourt les pastilles vite
    // en déclencherait sinon une par clic, et la dernière ne gagnerait pas
    // forcément la course.
    if (pending) pending.abort();
    var controller = new AbortController();
    pending = controller;

    var sep = url.indexOf('?') === -1 ? '?' : '&';
    fetch(url + sep + 'section_id=' + SECTION + '&variant=' + variantId,
          { signal: controller.signal })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        pending = null;
        if (html === null) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var block = tmp.querySelector('.cp');
        var markup = block ? block.outerHTML : '';
        cache[variantId] = markup;
        swap(markup);
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        pending = null;
      });
  }

  function swap(markup) {
    host = mount();
    if (!host) return;
    host.innerHTML = markup;
    // Un produit peut n'avoir aucun complément sur certains coloris : on masque
    // le conteneur au lieu de laisser un filet de séparation orphelin.
    host.hidden = markup === '';
  }

  function onVariant(evt) {
    var variant = evt && evt.detail && evt.detail.variant;
    if (variant && variant.id) render(variant.id);
  }

  document.addEventListener('variant:change', onVariant);
  document.addEventListener('product:variant-change', onVariant);
})();
